<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Байршил засах</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header">
          <div class="row form-group">
            <div class="col col-3">
              <label for="text-input" class="form-control-label">Нэр*</label>
            </div>
            <div class="col-9">
              <input
                type="text"
                id="text-input"
                name="text-input"
                class="form-control"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'form-control is-invalid': $v.name.$error }"
                v-model="name"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('name')[0] }}</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="default-tab">
            <div class="d-flex">
              <div
                :class="[{ 'tab--selected' : languageTab === 'MN', 'tab--invalid': mnTabError && languageTab !== 'MN' }, 'nav-link tab']"
                @click="languageTab = 'MN'"
              >MON</div>
              <div
                :class="[{ 'tab--selected' : languageTab === 'EN', 'tab--invalid': enTabError && languageTab !== 'EN' }, 'nav-link tab']"
                @click="languageTab = 'EN'"
              >ENG</div>
            </div>

            <br>
            <!-- MN tab -->
            <div v-if="languageTab === 'MN'">
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Гарчиг*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.0', $v.mntitle)"
                    :class="{ 'is-invalid': $v.mntitle.$error }"
                    v-model="mntitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Зураг (thumb)*</label>
                </div>
                <div class="col-9">
                  <div class="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      class="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      @change="onThumbInput($event, true)"
                      :class="{ 'is-invalid': $v.mnthumb.$error }"
                    >
                    <div class="invalid-feedback">{{ this.getErrorMsg('thumb.0')[0] }}</div>
                    <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                  </div>
                  <img class="thumb-image mt-4" v-if="mnthumb !== ''" v-bind:src="mnthumb" alt>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="select" class="form-control-label">Холбоо барих*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('phone.0', $v.mnphone)"
                    :class="{ 'is-invalid': $v.mnphone.$error }"
                    v-model="mnphone"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('phone.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Цагийн хуваарь*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('timeTable.0', $v.mntimetable)"
                    :class="{ 'is-invalid': $v.mntimetable.$error }"
                    v-model="mntimetable"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('timeTable.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Хаяг*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('address.0', $v.mnaddress)"
                    :class="{ 'is-invalid': $v.mnaddress.$error }"
                    v-model="mnaddress"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('address.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Газрын зурагны линк</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('mapUrl.0', $v.mnmapurl)"
                    :class="{ 'is-invalid': $v.mnmapurl.$error }"
                    v-model="mnmapurl"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('mapUrl.0')[0] }}</div>
                </div>
              </div>
            </div>

            <!-- EN tab -->
            <div v-else-if="languageTab === 'EN'">
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Гарчиг{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.1', $v.entitle)"
                    :class="{ 'is-invalid': $v.entitle.$error }"
                    v-model="entitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Зураг (thumb){{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <div class="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      class="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      @change="onThumbInput($event, false)"
                      :class="{ 'is-invalid': $v.enthumb.$error }"
                    >
                    <div class="invalid-feedback">{{ this.getErrorMsg('thumb.1')[0] }}</div>
                    <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                  </div>
                  <img class="thumb-image mt-4" v-if="enthumb !== ''" v-bind:src="enthumb" alt>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="select" class="form-control-label">Холбоо барих{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('phone.1', $v.enphone)"
                    :class="{ 'is-invalid': $v.enphone.$error }"
                    v-model="enphone"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('phone.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Цагийн хуваарь{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('timeTable.1', $v.entimetable)"
                    :class="{ 'is-invalid': $v.entimetable.$error }"
                    v-model="entimetable"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('timeTable.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Хаяг{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('address.1', $v.enaddress)"
                    :class="{ 'is-invalid': $v.enaddress.$error }"
                    v-model="enaddress"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('address.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Газрын зурагны линк</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('mapUrl.1', $v.enmapurl)"
                    :class="{ 'is-invalid': $v.enmapurl.$error }"
                    v-model="enmapurl"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('mapUrl.1')[0] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
          <button @click="$parent.goBack()" type="submit" class="btn btn-primary mx-2">Буцах</button>
          <button @click="onSubmit" type="submit" class="btn btn-success">
            <i class="fa fa-dot-circle"></i> Хадгалах
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuService from "@/services/MenuService";
import Form from "@/mixins/Form.js";
import ImageUploadService from "@/services/ImageUploadService";

export default {
  name: "BranchCreate",

  mixins: [Form],

  props: ["entryId", "parentId"],

  created() {
    this.$store.dispatch("setLoading", true);
    this.getEntry();
  },

  computed: {
    mnTabError() {
      return (
        this.$v.mntitle.$error ||
        this.$v.mnthumb.$error ||
        this.$v.mnphone.$error ||
        this.$v.mntimetable.$error ||
        this.$v.mnaddress.$error ||
        this.$v.mnmapurl.$error
      );
    },

    enTabError() {
      return (
        this.$v.entitle.$error ||
        this.$v.enthumb.$error ||
        this.$v.enphone.$error ||
        this.$v.entimetable.$error ||
        this.$v.enaddress.$error ||
        this.$v.enmapurl.$error
      );
    },

    notOptional() {
      return this.hasEngdata() ? "*" : "";
    }
  },

  data() {
    return {
      name: "",
      mntitle: "",
      entitle: "",
      mnthumb: "",
      enthumb: "",
      mnphone: "",
      enphone: "",
      mntimetable: "",
      entimetable: "",
      mnaddress: "",
      enaddress: "",
      mnmapurl: "",
      enmapurl: ""
    };
  },

  validations: {
    name: {
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    mntitle: {
      serverFailed: function() {
        return !this.hasServerError("title.0");
      }
    },
    entitle: {
      serverFailed: function() {
        return !this.hasServerError("title.1");
      }
    },
    mnthumb: {
      serverFailed: function() {
        return !this.hasServerError("thumb.0");
      }
    },
    enthumb: {
      serverFailed: function() {
        return !this.hasServerError("thumb.1");
      }
    },
    mnphone: {
      serverFailed: function() {
        return !this.hasServerError("phone.0");
      }
    },
    enphone: {
      serverFailed: function() {
        return !this.hasServerError("phone.1");
      }
    },
    mntimetable: {
      serverFailed: function() {
        return !this.hasServerError("timeTable.0");
      }
    },
    entimetable: {
      serverFailed: function() {
        return !this.hasServerError("timeTable.1");
      }
    },
    mnaddress: {
      serverFailed: function() {
        return !this.hasServerError("address.0");
      }
    },
    enaddress: {
      serverFailed: function() {
        return !this.hasServerError("address.1");
      }
    },
    mnmapurl: {
      serverFailed: function() {
        return !this.hasServerError("mapUrl.0");
      }
    },
    enmapurl: {
      serverFailed: function() {
        return !this.hasServerError("mapUrl.1");
      }
    }
  },

  methods: {
    getEntry() {
      MenuService.getEntry({}, this.entryId).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.name = response.data.payload.name;
          let mncontent = response.data.payload.contents[0];

          this.mntitle = mncontent.title;
          this.mnthumb = mncontent.thumb;
          let mncontentbody = JSON.parse(mncontent.body);
          this.mnphone = mncontentbody.phone;
          this.mntimetable = mncontentbody.timeTable;
          this.mnaddress = mncontentbody.address;
          if (mncontentbody.mapUrl) this.mnmapurl = mncontentbody.mapUrl;

          let encontent = response.data.payload.contents[1];
          if (encontent != null) {
            this.entitle = encontent.title;
            this.enthumb = encontent.thumb;
            let encontentbody = JSON.parse(encontent.body);
            this.enphone = encontentbody.phone;
            this.entimetable = encontentbody.timeTable;
            this.enaddress = encontentbody.address;
            if (encontentbody.mapUrl) this.enmapurl = encontentbody.mapUrl;
          }
        }

        this.$store.dispatch("setLoading", false);
      });
    },

    serverRequest: MenuService.editBranch,

    successHandler(response) {
      if (response.data.payload.toast != null)
        this.showToast(response.data.payload.toast);

      this.$parent.goBack();
    },

    createJsonData() {
      let data = JSON.parse("{}");
      data.id = this.entryId;
      data.name = this.name;
      data.contents = [];

      let mncontent = JSON.parse("{}");
      mncontent.language = 1;
      mncontent.title = this.mntitle;
      mncontent.thumb = this.mnthumb;
      mncontent.phone = this.mnphone;
      mncontent.timeTable = this.mntimetable;
      mncontent.address = this.mnaddress;
      if (this.mnmapurl != "") mncontent.mapUrl = this.mnmapurl;
      data.contents.push(mncontent);

      if (this.hasEngdata()) {
        let encontent = JSON.parse("{}");
        encontent.language = 2;
        encontent.title = this.entitle;
        encontent.thumb = this.enthumb;
        encontent.phone = this.enphone;
        encontent.timeTable = this.entimetable;
        encontent.address = this.enaddress;
        if (this.enmapurl != "") encontent.mapUrl = this.enmapurl;
        data.contents.push(encontent);
      }
      return data;
    },

    hasEngdata() {
      return (
        this.entitle != "" ||
        this.enphone != "" ||
        this.enthumb != "" ||
        this.entimetable != "" ||
        this.enaddress != ""
      );
    },

    onThumbInput(event, isMon) {
      if (event.target.files[0] != null) {
        const data = new FormData();
        data.append("image", event.target.files[0]);
        ImageUploadService.uploadImage(data).then(response => {
          if (isMon) {
            this.mnthumb = response.data;
            this.onChangeHandler("thumb.0", this.$v.mnthumb);
          } else {
            this.enthumb = response.data;
            this.onChangeHandler("thumb.1", this.$v.enthumb);
          }
        });
      }
    }
  }
};
</script>